import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useJournal } from "../lib/usePortfolio";
import StoryCard from "./StoryCard";

const EASE = [0.22, 1, 0.36, 1];

export default function JournalStrip() {
  const { data } = useJournal();
  const stories = (data ?? []).slice(0, 3);
  if (stories.length === 0) return null;

  return (
    <section id="journal" data-testid="journal-strip-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.header
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="flex flex-wrap items-end justify-between gap-6"
        >
          <div>
            <p className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-500">06 // The Journal</p>
            <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-normal tracking-tight text-ivory">
              Featured <span className="italic text-champagne">Weddings</span>
            </h2>
          </div>
          <Link
            to="/journal"
            data-testid="journal-strip-all-link"
            className="border border-champagne/40 px-5 py-2 text-[11px] font-mono tracking-[0.2em] uppercase text-champagne hover:bg-champagne hover:text-obsidian transition-colors duration-300"
          >
            Read the Journal
          </Link>
        </motion.header>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {stories.map((s, i) => <StoryCard key={s.id} story={s} index={i} />)}
        </div>
      </div>
    </section>
  );
}
